import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusCardSubhead], [campus-card-subhead], campus-card-subhead',
})
export class CardSubheadDirective {
  @HostBinding('class')
  defaultClasses = ['title-small'];
}
